import './App.css';
import React, { useEffect, useState } from 'react';
import { useLocalStorage, useMount, useLocation } from 'react-use';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { AnimatePresence, motion } from 'framer-motion';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routes from '../routes/index';
import ProtectedRoute from '../routes/ProtectedRoutes';
import Header from './shared-components/header/Header';
import Footer from './shared-components/footer/Footer';
import Notifications from './shared-components/notifications/Notifications';
import envConfig from '../envConfig';
import MenuSideBar from './shared-components/menu-sidebar/MenuSideBar';
import { Spinner } from './shared-components/Spinner';
import NewSubmissionSuccessModal from './shared-components/modals/NewSubmissionSuccessModal';

function App() {
  if (!String.prototype.format) {
    String.prototype.format = function () {
      const args = arguments;
      return this.replace(/{(\d+)}/g, function (match, number) { 
        return typeof args[number] !== 'undefined'
          ? args[number]
          : match;
      });
    };
  }

  const { i18n } = useTranslation();
  const location = useLocation();
  const [language] = useLocalStorage(`${envConfig.StoragePrefix}-lang`);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    setTimeout(() => setInitializing(false), 1500);
  }, []);
 
  useMount(() => {
    if (language) {
      localStorage.setItem(`${envConfig.StoragePrefix}-lang`, JSON.stringify(language))
      i18n.changeLanguage(language);
    } else {
      i18n.changeLanguage(envConfig.DefaultLanguage);
      localStorage.setItem(`${envConfig.StoragePrefix}-lang`, JSON.stringify(envConfig.DefaultLanguage))
    }
  });

  return (
    <div className="wrapper antialiased overflow-auto bg-offwhite">
      <AnimatePresence mode="wait" initial={false}>
        <Router>
          <Header key="header" />
          <div className="" key="body">
            <Switch location={location} key={location.pathname}>
              {_.map(routes, (route) => {
                if (route.protected) {
                  return (
                    <ProtectedRoute
                      key={route.id}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                    />
                  );
                }
                return (
                  <Route
                    key={route.id}
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                  />
                );
              })}
            </Switch>
          </div>
          <Footer key="footer" />
        </Router>

        <NewSubmissionSuccessModal />
        <Notifications key="notif" />
        <MenuSideBar />

        <motion.div
          initial="visible"
          animate="hidden"
          exit="visible"
          className={`${initializing ? 'fixed' : 'hidden'} fixed bg-white inset-0 z-20`}
        >
          <div className="bg-white flex h-full loading-screen-full-white">
            <Spinner className="text-primaryColor mx-auto my-auto" big />
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;
